module.exports = __webpack_public_path__ + "static/us-enterprise-cut-costs-66328693c86e7d5e070e6251c78562d6.gif";